import { createApp } from 'vue';
import { initMetrics } from '@/assets/js/marketing-scripts';
import { wrapRouter } from '@/utils/routerWithUtm';
import { router as routerEn } from '@/router/en';
import { router as routerRu } from '@/router/ru';
import config from '@/config';
import App from '@/App.vue';

import '@/assets/sass/public-plans/app.sass';
import { localeStore } from './locale';

let lang = 'en';
Object.entries(config.domains).some(([domainName, language]) => {
  const isAnotherDomain = window.location.origin.includes(domainName);
  if (isAnotherDomain) lang = language;
  return isAnotherDomain;
});
const router = lang === 'ru' ? routerRu : routerEn;
localeStore.setLang(lang);

const app = createApp(App);
const wrappedRouter = wrapRouter(router);
app.use(wrappedRouter).mount('#app');

const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap';
link.rel = 'stylesheet';
document.head.appendChild(link);

if (lang === 'ru') {
  import('@/assets/sass/ru/app.sass');
} else {
  import('@/assets/sass/en/app.sass');
}

const initSentry = async () => {
  const { dsn, environment } = config.sentry ?? {};
  if (!dsn || environment === 'development') return;

  const Sentry = await import('@sentry/vue');

  try {
    Sentry.init({
      app,
      dsn: config.sentry.dsn,
      environment: config.sentry.environment,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: 0.01,
      replaysSessionSampleRate: 0.005,
      replaysOnErrorSampleRate: 1.0,
    });
  } catch (error) {
    console.error('Failed to load or initialize Sentry:', error);
  }
};

initMetrics(lang);
initSentry();

if (lang === 'ru') {
  const yookassaScript = document.createElement('script');
  yookassaScript.async = true;
  yookassaScript.src = 'https://yookassa.ru/checkout-widget/v1/checkout-widget.js';
  document.body.appendChild(yookassaScript);
}
